import { defineComponent as _defineComponent } from 'vue'
import Navigation from "../../../NavigationContainer.vue";
import { ref, onMounted, reactive, onUpdated, watch } from "vue";
import { useI18n } from "vue3-i18n";
import { store } from "@/store/store";
import { useRouter } from "vue-router";
import Loading from "@/components/home/Loading";
import Alert from "@/components/scan/parts/Alert.vue";
import SalesNoteLinkNavigation from "../../../KDPSalesNoteLinkNavigationContainer.vue";
import SalesNoteHeaderNavigation from "../../../KDPSalesNoteHeaderNavigationContainer.vue";
import IssueSalesNoteDataService from "@/services/KDPIssueSalesNoteDataService";
import KDPConfimrSalesNoteDataService from "@/services/KDPConfirmSalesNoteDataService";
import ResponseData from "@/types/ResponseData";
import KDPSalesNote from "@/types/KDPSalesNote";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(false)
const alertMessage = ref("null")
const alertState = ref("neutral")
const i18n = useI18n()
const router = useRouter()
const btnFlg = ref(true)
const chkCheck = ref(false)
const paramSalesNote = reactive([])
const nextParamSalesNote = reactive<KDPSalesNote[]>([])
const salesNoteCount = ref(0)
const currentSalesNoteCount = ref(0)
const strSalesNo = ref("")
const strProdYM = ref("")
const strPDFCreatedYM = ref("")
const strSeqNo = ref("")
const strParentCd = ref("")
const strDistCd = ref("")
const pdfurl = ref(" ")
const txtMessage =  ref("")
const subFolderPDF = ref('')
const pdfFileName = ref('')
const kdpSalesNoteScreenFlg = ref("Issuse")
const pdfFileHeight = ref('calc(100% - 135px)')

// Confirm Sales Note
const approveRejectList = reactive([])
const distApproveList = reactive([])
const distUser = ref(-1);
const smcUser = ref("");
const isAppRejFlg = ref('')
const drafterId = ref("")
const distConfirmer1Id = ref("")
const distConfirmer2Id = ref("")
const distConfirmer3Id = ref("")
const distConfirmer4Id = ref("")
const distConfirmer5Id = ref("")
const distApproverId = ref("")
const approverId = ref("")
const btnPressFlg = ref("")
const btnShowText = ref("")

onMounted(function () {
  isLoading.value = true
  // 画面元のチェック
  if (store.getters.kdpSalesNoteScreen == "KDPConfirmSalesNote") {
    kdpSalesNoteScreenFlg.value = "Confirm";
    pdfFileHeight.value = "calc(100% - 200px)"
  }
  
  nextParamSalesNote.splice(0);

  // パラメータ取得
  paramSalesNote.splice(0)
  paramSalesNote.push(...store.getters.paramKDPSalesNoteList)

  // 合計のセールスノートカウント
  salesNoteCount.value = paramSalesNote.length
  
  // PDFのURL取得
  currentSalesNoteInfo()

  if (kdpSalesNoteScreenFlg.value == "Confirm") {
    approveRejectList.splice(0);
    distApproveList.splice(0);

    checkDistConfirmer()
    checkSMCConfirmer()
  }
});

// 現在のセールスノート情報
const currentSalesNoteInfo = () => {
  if (currentSalesNoteCount.value !== salesNoteCount.value) {
    strSalesNo.value = paramSalesNote[currentSalesNoteCount.value]?.salesNo
    strProdYM.value = paramSalesNote[currentSalesNoteCount.value]?.prodYM
    strPDFCreatedYM.value = paramSalesNote[currentSalesNoteCount.value]?.pdfCreatedYM
    strSeqNo.value = paramSalesNote[currentSalesNoteCount.value]?.seqNo
    strParentCd.value = paramSalesNote[currentSalesNoteCount.value]?.parentCD
    strDistCd.value = paramSalesNote[currentSalesNoteCount.value]?.distCD

    subFolderPDF.value = strPDFCreatedYM.value + "_" + strSalesNo.value + "_" + strParentCd.value + "_" + strDistCd.value + "_" + strSeqNo.value
    pdfFileName.value = subFolderPDF.value + "/" + strSalesNo.value + ".pdf"

    getPreSignedUrl()
  }
}

// pdfのurl取得
const getPreSignedUrl = () => {
  pdfurl.value = " ";
  // 二回目実行にアラートメッセージが表示修正
  alertMessage.value = "null"
  alertState.value = "neutral"

  const data = { 
    'fileName' : pdfFileName.value,
    'userId' : store.getters.cognitoUserName 
  }

  IssueSalesNoteDataService.getPreSignedUrl(data)
  .then((response: ResponseData) => {
    pdfurl.value = response.data
    if (kdpSalesNoteScreenFlg.value == "Issuse") {
      isLoading.value = false
    }
  })
  .catch((e: Error) => {
    pdfurl.value = ''
    alertMessage.value = i18n.t("err102")
    alertState.value = "error"
    isLoading.value = false
  });
}

// チェックボックス変更イベント
const chkCheckChange = (event : any) => {
  if (event.target.checked) {
    btnFlg.value = false;
  } else {
    btnFlg.value = true;
  }
}

// IssueSaesNote_次へボタンイベント
const goNext = () => {
  // ステータスの更新
  updateStatus("Next")
}

// IssueSaesNote_Cancelボタンイベント
const goCancel = () => {
  // ステータスの更新
  updateStatus("Cancel")
}

// IssueSaesNote_ステータスの更新
const updateStatus = (btnStatus : string) => {
  isLoading.value = true;

  // 二回目実行にアラートメッセージが表示修正
  alertMessage.value = "null";
  alertState.value = "neutral";

  // パラメータ
  const salesNoteInfo = {
    btnStatus : btnStatus,
    salesNo : paramSalesNote[currentSalesNoteCount.value]?.salesNo,
    seqNo : paramSalesNote[currentSalesNoteCount.value]?.seqNo,
    userId : store.getters.cognitoUserName
  }  

  IssueSalesNoteDataService.updateKDPSalesNoteApprovalStatus(salesNoteInfo)
    .then((response: ResponseData) => {
      if (response.data.message == 'success') {
        if (btnStatus == 'Next') {
          nextParamSalesNote.push(paramSalesNote[currentSalesNoteCount.value])
        }

        currentSalesNoteCount.value += 1;
        // PDFのURL取得
        currentSalesNoteInfo();

        chkCheck.value = false;
        btnFlg.value = true;

        // 画面遷移
        if (currentSalesNoteCount.value == salesNoteCount.value) {
          if (nextParamSalesNote.length > 0) {
            // KDPConfirmationRoute画面へ遷移
            store.dispatch("setParamKDPSalesNoteList", nextParamSalesNote);
            router.push("/KDPConfirmationRoute");
          } else {
            // 一覧画面へ戻る
            store.dispatch("setParamKDPSalesNoteList", null);
            // 検索モードで表示するため
            var searchInfo = store.getters.kdpSalesNoteSearchData || null;
            searchInfo.mode = 'Search';
            store.dispatch("setKDPSalesNoteSearchData", searchInfo);
            router.push("/KDPIssueSalesNote");
          }
        }
      }
      isLoading.value = false;
      pdfurl.value = " ";
    })
    .catch((e: Error) => {
      alertMessage.value = i18n.t("err098");
      alertState.value = "error";
      isLoading.value = false;
    });
}

// ConfirmSalesNote_Distributor確認者チェック
const checkDistConfirmer = () => {
  const data = { 
      userId: store.getters.cognitoUserName,
      strSalesNo: strSalesNo.value,
      strSeqNo: strSeqNo.value
  }
  KDPConfimrSalesNoteDataService.checkDistConfirmer(data)
    .then((response: ResponseData) => {
      if (response.data) {
        distUser.value = parseInt(response.data.dist_user_flg, 10)
        if (store.getters.stationCode != '1000') {
          if (distUser.value != 0) {
            btnShowText.value = 'Confirm'
          } else {
            btnShowText.value = 'Approve'
          }
        }
      }
    })
    .catch((error: ResponseData) => {  
      alertMessage.value = i18n.t("err112");
      alertState.value = "error";
      isLoading.value = false;
  });
}

// ConfirmSalesNote_SMC確認者チェック
const checkSMCConfirmer = () => {

  const data = { 
      userId: store.getters.cognitoUserName,
      strSalesNo: strSalesNo.value,
      strSeqNo: strSeqNo.value
  }
  KDPConfimrSalesNoteDataService.checkSMCConfirmer(data)
    .then((response: ResponseData) => {
      if (response.data) {
        smcUser.value = response.data.smc_user_flg
        if (store.getters.stationCode == '1000') {
          if (smcUser.value == 'C') {
            btnShowText.value = 'Confirm'
          } else {
            btnShowText.value = 'Approve'
          }
        }
      }
      isLoading.value = false; 
    })
    .catch((error: ResponseData) => { 
      alertMessage.value = i18n.t("err113");
      alertState.value = "error";
      isLoading.value = false;
    });
}

// ConfirmSalesNote_Confirm/Approveボタンイベント
const goApprove = () => {
  // "Are You Sure Approved?";
  var confmsg = confirm(i18n.t("cnf014"));
  if (confmsg == true) {
    // 二回目実行にアラートメッセージが表示修正
    alertMessage.value = "null";
    alertState.value = "neutral";

    if (store.getters.stationCode == '1000') {
		  isAppRejFlg.value =  "SMCApp"
	  }
	  else{
		  isAppRejFlg.value =  "DistrApp"
    }
    btnPressFlg.value = "Approve"
    // Confirm/Approveリストにデータ追加
    addDatatoList()
  }
}

// ConfirmSalesNote_Rejectボタンイベント
const goReject = () => {

  if (txtMessage.value == "") {
    // "Please input (Message：)"
		alert(i18n.t("alt104"))
		return
	} else {
    // 二回目実行にアラートメッセージが表示修正
    alertMessage.value = "null";
    alertState.value = "neutral";

    // Are You Sure Rejected?
    var confMsg = confirm(i18n.t("cnf015"))
		if (confMsg == true) {
      if (store.getters.stationCode == '1000') {
        isAppRejFlg.value = "SMCRej"; 
      } else {
        isAppRejFlg.value = "DistrRej"; 
      }
      btnPressFlg.value = "Reject"
      // Rejectリストにデータ追加
      addDatatoList()  
		}
	}
}

// ConfirmSalesNote_次のSalesNoある場合表示/ない場合データベース更新
const isNextSalesNote = () => {
  currentSalesNoteCount.value += 1
  // PDFのURL取得
  currentSalesNoteInfo()

  chkCheck.value = false
  btnFlg.value = true
  txtMessage.value = ''

  // 次のSalesNoがない場合データベース更新
  if (currentSalesNoteCount.value == salesNoteCount.value) {
    confirmsnApproveReject()
  } else {
      if (store.getters.stationCode == '1000') {
        checkSMCConfirmer()
      } else {
        checkDistConfirmer()
      }
    if (btnPressFlg.value == 'Approve') {
      // Sales Note Is Approved.
      alert(i18n.t("alt105"))
      btnPressFlg.value = ''
    } 
    if (btnPressFlg.value == 'Reject') {
      // Sales Note Is Rejected.
      alert(i18n.t("alt106"))
      btnPressFlg.value = ''
    }
    isLoading.value = false
  }
}

// ConfirmSalesNote_Confirm/Approve/Rejectリストにデータ追加
const addDatatoList = () => {
  isLoading.value = true

  const data = { 
      strSalesNo: strSalesNo.value,
      strSeqNo: strSeqNo.value,
      userId: store.getters.cognitoUserName
  }
  KDPConfimrSalesNoteDataService.setUserID(data)
    .then((response: ResponseData) => {
      if (response.data) {
        drafterId.value = response.data.drafterId
        distConfirmer1Id.value = response.data.distributorConfirmer1Id
        distConfirmer2Id.value = response.data.distributorConfirmer2Id
        distConfirmer3Id.value = response.data.distributorConfirmer3Id
        distConfirmer4Id.value = response.data.distributorConfirmer4Id
        distConfirmer5Id.value = response.data.distributorConfirmer5Id
        distApproverId.value = response.data.distributorApproverId
        approverId.value = response.data.approverId

        // 代理店名取得
        const lambdadData = {
          functionName: "getDistributorName",
          distCd : strParentCd.value
        }
        KDPConfimrSalesNoteDataService.getDistributorName_v2(lambdadData)
          .then((res: ResponseData) => {

            if (isAppRejFlg.value == 'DistrApp') {
              // Distributor Confirm/Approveリストにデータ追加
              distApproveList.push({
                saleNo: strSalesNo.value,
                prodYM: strProdYM.value,
                seqNo: strSeqNo.value,
                distCD: strDistCd.value,
                distUser: distUser.value,
                distributorApproverId : distApproverId.value,
                distributor_name : res.data.distributor_name
              })
            } else {
              // Confirm/Approve/Rejectリストにデータ追加
              approveRejectList.push({
                saleNo: strSalesNo.value,
                prodYM: strProdYM.value,
                seqNo: strSeqNo.value,
                parentDistCD: strParentCd.value,
                distCD: strDistCd.value,
                distributor_name : res.data.distributor_name,
                drafterId: drafterId.value,
                approverId: approverId.value,
                distributorConfirmer1Id: distConfirmer1Id.value,
                distributorConfirmer2Id: distConfirmer2Id.value,
                distributorConfirmer3Id: distConfirmer3Id.value,
                distributorConfirmer4Id: distConfirmer4Id.value,
                distributorConfirmer5Id: distConfirmer5Id.value,
                distributorApproverId : distApproverId.value,
                appRejFlg: isAppRejFlg.value,
                message: txtMessage.value
              })
            }
            isNextSalesNote()

           })
          .catch((error: ResponseData) => { 
            alertMessage.value = i18n.t("err114");
            alertState.value = "error";
            isLoading.value = false;
          })
      }
    })
    .catch((error: ResponseData) => { 
      alertMessage.value = i18n.t("err114");
      alertState.value = "error";
      isLoading.value = false;
    });
}

// ConfirmSalesNote_Backボタンイベント
const goBack = () => {
  isLoading.value = true

  // 二回目実行にアラートメッセージが表示修正
  alertMessage.value = "null";
  alertState.value = "neutral";
  
  // ConfirmSalesNote_データ更新処理
  confirmsnApproveReject()
}

// ConfirmSalesNote_データ更新処理
const confirmsnApproveReject = () => {
  // ディストリビュータ承認者が承認したセールスチェック
  if (distApproveList.length != 0) {
    sendDistrAppMail()
  } else {
    // 承認、確認、却下のデータチェック
    if (approveRejectList.length != 0) {
      updateChangedData()
    } else {
      isLoading.value = false      
      
      // 【Confrim Sales Note】画面へ移動
      router.push("/KDPConfirmSalesNote");
    }
  }
}

const sendDistrAppMail = () => {
  const data = { 
      userId: store.getters.cognitoUserName,
      distApproveList: distApproveList,
      menuCD: store.getters.mainMenuCode
  }
  KDPConfimrSalesNoteDataService.sendDistrAppMail(data)
    .then((response: ResponseData) => {
      // 承認、確認、却下のデータチェック
      if (approveRejectList.length != 0) {
        updateChangedData()
      } else {
        isLoading.value = false;   
        if (btnPressFlg.value == 'Approve') {
          // Sales Note Is Approved.
          alert(i18n.t("alt105"))
          btnPressFlg.value = ''
        } 
        if (btnPressFlg.value == 'Reject') {
          // Sales Note Is Rejected.
          alert(i18n.t("alt106"))
          btnPressFlg.value = ''
        }
        // 【Confrim Sales Note】画面へ移動
        router.push("/KDPConfirmSalesNote");
      }
    })
    .catch((error: ResponseData) => { 
      alertMessage.value = i18n.t("err115");
      alertState.value = "error";
      isLoading.value = false;
    });
}

const updateChangedData = () => {
  const data = { 
    userId: store.getters.cognitoUserName,
    approveRejectList: approveRejectList,
    menuCD: store.getters.mainMenuCode
  }
  KDPConfimrSalesNoteDataService.updateChangedData(data)
    .then((response: ResponseData) => {
      isLoading.value = false; 
      if (btnPressFlg.value == 'Approve') {
      // Sales Note Is Approved.
      alert(i18n.t("alt105"))
      btnPressFlg.value = ''
    } 
    if (btnPressFlg.value == 'Reject') {
      // Sales Note Is Rejected.
      alert(i18n.t("alt106"))
      btnPressFlg.value = ''
    }
      // 【Confrim Sales Note】画面へ移動
      router.push("/KDPConfirmSalesNote");
    })
    .catch((error: ResponseData) => { 
      alertMessage.value = i18n.t("err116");
      alertState.value = "error";
      isLoading.value = false;
    });
}

const __returned__ = { isLoading, alertMessage, alertState, i18n, router, btnFlg, chkCheck, paramSalesNote, nextParamSalesNote, salesNoteCount, currentSalesNoteCount, strSalesNo, strProdYM, strPDFCreatedYM, strSeqNo, strParentCd, strDistCd, pdfurl, txtMessage, subFolderPDF, pdfFileName, kdpSalesNoteScreenFlg, pdfFileHeight, approveRejectList, distApproveList, distUser, smcUser, isAppRejFlg, drafterId, distConfirmer1Id, distConfirmer2Id, distConfirmer3Id, distConfirmer4Id, distConfirmer5Id, distApproverId, approverId, btnPressFlg, btnShowText, currentSalesNoteInfo, getPreSignedUrl, chkCheckChange, goNext, goCancel, updateStatus, checkDistConfirmer, checkSMCConfirmer, goApprove, goReject, isNextSalesNote, addDatatoList, goBack, confirmsnApproveReject, sendDistrAppMail, updateChangedData, Navigation, Loading, Alert, SalesNoteLinkNavigation, SalesNoteHeaderNavigation }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})